import "amazon-connect-streams";

interface ParticipantIds {
    agentParticipantId: string;
    customerParticipantId: string;
}

/**
 * Extracts agent and customer participant IDs from a Connect contact.
 */
export function getParticipantIds(contact: connect.Contact): ParticipantIds {
    const agentConnection = contact.getAgentConnection() as connect.ChatConnection;
    const agentParticipantId = agentConnection.getMediaInfo().participantId;

    const customerConnection = contact.getInitialConnection() as connect.ChatConnection;
    const customerParticipantId = customerConnection.getMediaInfo().participantId;

    return { agentParticipantId, customerParticipantId };
}
